import React, { useContext } from "react";
import { DataContext } from "../../../Context/Context";
import { Link } from "react-router-dom";

const HomeListings = () => {
  const { listings = [], loading } = useContext(DataContext);

  return (
    <section className="py-20">
      <div className="container">
        <div className="text-center">
          <p className="text-xl text-gray-500 mb-3">Browse</p>
          <h2 className="md:text-4xl text-2xl font-bold text-[#4d4b47]">
            Apartments & Villas
          </h2>
        </div>
        {loading ? (
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 grid-cols-1 mt-10">
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="skeleton h-56 w-full"></div>
              <div className="skeleton h-4 w-full"></div>
            </div>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 grid-cols-1 mt-10">
            {listings?.slice(0, 6).map((listing, index) => (
              <Link
                to={`/listing/${listing.slug}`}
                className="hover:no-underline active:no-underline focus:no-underline"
                key={index}
              >
                <img
                  src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                    listing?.listingImages[0]?.url,
                  )}&w=400&q=70&format=webp`}
                  alt=""
                />
                <div className="mt-4">
                  <p className="leading-[26px] font-semibold text-[#74716d] text-[16px]">
                    {listing?.name}
                  </p>
                  <div className="flex items-center gap-1 text-[#74716d] mt-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1.2em"
                      height="1.2em"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M12 12q.825 0 1.413-.587T14 10t-.587-1.412T12 8t-1.412.588T10 10t.588 1.413T12 12m0 10q-4.025-3.425-6.012-6.362T4 10.2q0-3.75 2.413-5.975T12 2t5.588 2.225T20 10.2q0 2.5-1.987 5.438T12 22"
                      />
                    </svg>
                    <span>{listing?.city}</span>
                  </div>
                  {/* <div className="flex items-center gap-1 text-[#74716d] mt-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1.3em"
                      height="1.3em"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6zm-4 5v2h2v-2z"
                      />
                    </svg>
                    <span>{listing?.bedroomsNumber} Bedrooms</span>
                  </div> */}
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="flex items-center justify-center mt-8">
          <button className="bg-[#4d4b47] px-6 py-2 rounded-md">
            <a
              href="/properties"
              className="text-white hover:text-white hover:no-underline active:text-white focus:text-white active:no-underline focus:no-underline"
            >
              Explore More
            </a>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeListings;
